import { Model } from '@vuex-orm/core';
import { v4 as uuid } from 'uuid';
import StudyContract from '@/study/StudyContract';
import ImageContract from '@/image/ImageContract';
import LinkContract from '@/study/LinkContract';
import Location from '@/location/Location';
import LocationContract from '@/location/LocationContract';
import Fields from '@vuex-orm/core/lib/model/contracts/Fields';

export default class Study extends Model implements StudyContract {
    static entity = 'studies';
    static primaryKey = 'id';

    public id!: string;
    public location_id!: string;
    public name!: string;
    public subtitle!: string;
    public link!: LinkContract;
    public image!: ImageContract;
    public location!: LocationContract;

    static fields(): Fields {
        return {
            id: this.uid(() => uuid()),
            location_id: this.uid(() => uuid()),
            location: this.belongsTo(Location, 'location_id'),
            name: this.string(''),
            subtitle: this.attr(null),
            link: this.attr(null),
            image: this.attr(null),
        };
    }
}
